<template>
  <div
    class="flex flex-col items-center justify-center pass-expired-success-wrapper"
  >
    <graphic-base width="110" height="110" view-box="0 0 100 100">
      <circle-check />
    </graphic-base>
    <div class="text-center my-12 text-center w-3/4">
      <h1 class="success-message text-zt-xl mb-4">
        {{
          $t('message.loginComponent.passwordExpired.success.success_message')
        }}
      </h1>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import CircleCheck from '@/components/commons/Illustrations/graphicSVG/circleCheck'
export default {
  name: 'ztAuthResetPassSuccess',
  components: { CircleCheck, GraphicBase },

  methods: {}
}
</script>

<style scoped lang="scss">
.pass-expired-success-wrapper {
  height: 394px;
}

::v-deep .zt-button {
  height: 3.25rem;
}

.success-message {
  color: #0081c6;
}
</style>
